import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { MyAccountPipelinesQuery } from '@/gql/graphql';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';

const GetMyAccountPipelinesQuery = graphql(`
  query MyAccountPipelines {
    me {
      user {
        account {
          pipelines {
            id
            publicId
            title
            colour
            type
            stages {
              id
              publicId
              title
              colour
              index
            }
          }
        }
      }
    }
  }
`);

const useGetMyAccountPipelines = (
  options?: Partial<UseQueryOptions<MyAccountPipelinesQuery>>
) => {
  const { data, ...rest } = useQuery({
    ...options,
    queryKey: meKeys.accountPipelines(),
    queryFn: () => {
      return gqlClient.request(GetMyAccountPipelinesQuery);
    },
  });

  return { data: data?.me.user.account.pipelines, ...rest };
};

export default useGetMyAccountPipelines;
